import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import HR from 'UIComponents/elements/HR';
import FormattedList from 'I18n/components/FormattedList';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import FormattedTimeDelay from 'automation-ui-action-features/components/delay/FormattedTimeDelay';
import EventTypeLabelFromSegmentationFilters from 'automation-ui-action-features/actions/wait-until/EventTypeLabelFromSegmentationFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function WaitUntilActionDetail({
  actionMetadata,
  getActionLabelById,
  messageLangPath = 'actionDetail'
}) {
  const eventFilters = actionMetadata.getEventFilters();
  const expiration = actionMetadata.getExpiration();
  const firstEventFilter = eventFilters.get(0);
  if (!firstEventFilter) {
    return /*#__PURE__*/_jsx(MissingLabel, {
      type: "event"
    });
  }
  const sourceActionId = actionMetadata.getTargetActionId();
  let eventTypeLabel;
  // Data passing-specific label, only uses "Property value changed" event
  if (sourceActionId) {
    const sourceActionHeaderTitle = sourceActionId && getActionLabelById({
      actionId: sourceActionId
    });
    eventTypeLabel = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.wait-until.passed-data-action-config.event-types.property-value-changed",
      options: {
        sourceActionHeaderTitle: sourceActionHeaderTitle || /*#__PURE__*/_jsx(MissingLabel, {
          type: "action"
        })
      }
    });
  } else {
    eventTypeLabel = /*#__PURE__*/_jsx(FormattedList, {
      exclusive: true,
      children: actionMetadata.getEventFilters().map((eventFilter, index) => /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(EventTypeLabelFromSegmentationFilters, {
          eventTypeId: eventFilter.getEventFilter().eventTypeId
        })
      }, index))
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [eventTypeLabel, /*#__PURE__*/_jsx(HR, {
      className: "m-bottom-2 m-top-2"
    }), messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.wait-until.action-detail.max-time-form-label",
      options: {
        expiration: /*#__PURE__*/_jsx(FormattedTimeDelay, {
          timeDelay: expiration
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.wait-until.action-preview.max-time-form-label",
      options: {
        expiration: /*#__PURE__*/_jsx(FormattedTimeDelay, {
          timeDelay: expiration
        })
      }
    })]
  });
}
export default WaitUntilActionDetail;